<template>
    <v-dialog max-width="500px" v-model="inDialog" env_index persistent>
        <v-card>
            <v-form ref="viewPresentForm">
                <div class="headline dialog-header">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px">{{
                            $t(formCreateName)
                        }}</v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                        @click="onCancel"
                        icon
                        style="
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            color: #fff;
                        "
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-select
                                :items="types"
                                :label="$t('Loại đối tượng')"
                                v-model="item.typeId"
                                name="typeId"
                                item-value="categoryId"
                                item-text="categoryName"
                                v-validate="'required'"
                                :data-vv-as="$t('Loại đối tượng')"
                                :error-messages="errors.first('typeId')"
                                :disabled="item.partnerId ? true : false"
                                v-on:change="typeChange(item.typeId)"
                            />
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                type="text"
                                :label="$t('Mã đối tượng')"
                                v-model.trim="item.partnerCode"
                                name="partnerCode"
                                v-validate="'required'"
                                maxLength="250"
                                :error-messages="errors.first('partnerCode')"
                                :data-vv-as="$t('Mã đối tượng')"
                                disabled
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                type="text"
                                :label="$t('Tên đối tượng')"
                                v-model.trim="item.partnerName"
                                name="partnerName"
                                v-validate="'required'"
                                maxLength="250"
                                :error-messages="errors.first('partnerName')"
                                :data-vv-as="$t('Tên đối tượng')"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                type="email"
                                :label="$t('Email')"
                                v-model.trim="item.email"
                                name="email"
                                v-validate="'email'"
                                maxLength="250"
                                :error-messages="errors.first('email')"
                                :data-vv-as="$t('Email')"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                type="number"
                                :label="$t('Số điện thoại')"
                                v-model.trim="item.phone"
                                name="phone"
                                maxLength="250"
                                :error-messages="errors.first('phone')"
                                :data-vv-as="$t('Số điện thoại')"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                type="text"
                                :label="$t('Địa chỉ')"
                                v-model.trim="item.partnerAddress"
                                name="partnerAddress"
                                maxLength="250"
                                :error-messages="errors.first('partnerAddress')"
                                :data-vv-as="$t('Địa chỉ')"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                type="number"
                                :label="$t('Mã số thuế')"
                                v-model.trim="item.partnerTax"
                                name="partnerTax"
                                maxLength="250"
                                :error-messages="errors.first('partnerTax')"
                                :data-vv-as="$t('Mã số thuế')"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                type="number"
                                :label="$t('Số tài khoản')"
                                v-model.trim="item.accountNumber"
                                name="accountNumber"
                                maxLength="250"
                                :error-messages="errors.first('accountNumber')"
                                :data-vv-as="$t('Số tài khoản')"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                type="text"
                                :label="$t('Ghi chú')"
                                v-model.trim="item.note"
                                name="note"
                                maxLength="250"
                                :error-messages="errors.first('note')"
                                :data-vv-as="$t('Ghi chú')"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-select
                                :items="partnerStatus"
                                :label="$t('Trạng thái')"
                                v-model="item.status"
                                name="status"
                                item-value="value"
                                item-text="text"
                                v-validate="'required'"
                                :data-vv-as="$t('Trạng thái')"
                                :error-messages="errors.first('status')"
                            />
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-form>
            <div style="text-align: right">
                <v-btn color="primary" @click="onSave">
                    <v-icon dark left>save</v-icon>
                    {{ $t("lang.common.save") }}
                </v-btn>
                <v-btn color="error" @click="onCancel">
                    <v-icon dark left>cancel</v-icon>
                    {{ $t("lang.common.cancel") }}
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import { message } from "../../../services";
import axios from "axios";
import { cateContants } from "@/constants";

export default {
    name: "partner-create",
    components: { message, axios },
    props: {
        formCreateName: {
            type: String,
            default: '',
        },
        propsItem: {
            type: Object,
            default: () => {
                    return {}
                }
        },
        cDialog: {
            type: Boolean,
            default: false,
        },
        types: {
            type: Array,
            default: [],
        },
    },
    data: () => {
        return {
            formName: "Cập nhật đối tượng",
            inDialog: false,
            partnerStatus: cateContants.materialStatus,
            item: {
                accountNumber: "",
                bankId: 0,
                note: "",
                partnerAddress: "",
                partnerCode: "",
                partnerName: "",
                partnerTax: "",
                status: 1,
                typeId: '',
                email: "",
                phone: "",
            },
        };
    },
    watch: {
        propsItem: {
            handler(value) {
                if (value !== null) {
                    this.item = {
                        partnerId: value.partnerId,
                        accountNumber: value.accountNumber
                            ? value.accountNumber
                            : "",
                        bankId: value.bankId ? value.bankId : 0,
                        note: value.note ? value.note : "",
                        partnerAddress: value.partnerAddress
                            ? value.partnerAddress
                            : "",
                        partnerCode: value.partnerCode ? value.partnerCode : "",
                        partnerName: value.partnerName ? value.partnerName : "",
                        partnerTax: value.partnerTax ? value.partnerTax : "",
                        email: value.email ? value.email : "",
                        phone: value.phone ? value.phone : "",
                        status: value.status ? value.status : 0,
                        typeId: value.typeId ? value.typeId : 0,
                    };
                } else {
                    this.resetFrom();
                }
            },
            deep: true,
        },
        cDialog(value) {
            this.inDialog = value;
        },
        inDialog (value) {
            if(!value){
                this.$emit("closeCreateDialog", "");
            }
        },
    },
    methods: {
        resetFrom: function () {
            this.item = {
                accountNumber: "",
                bankId: 0,
                note: "",
                partnerAddress: "",
                partnerCode: "",
                partnerName: "",
                partnerTax: "",
                status: 1,
                typeId: '',
                email: "",
                phone: "",
            };
        },
        onCancel: function () {
            this.$emit("closeCreateDialog", "");
        },
        onSave: function () {
            
            this.$validator.validate().then((valid) => {
                if (!valid) {
                    message.error(this.$t("lang.common.validate_fail"));
                    return;
                }
                // if (!this.validEmail(this.item.email)) {
                //     message.error('Email không đúng định dạng');return;
                // }
                axios
                    .post(
                        process.env.VUE_APP_API_URL + "/partner/save",
                        this.item
                    )
                    .then(
                        (data) => {
                            console.log(data);
                            if (data.success) {
                                message.success(
                                    this.$t("lang.common.save_success")
                                );
                                this.resetFrom();
                                this.onCancel();
                            } else {
                                message.error(this.$t(data.description));
                            }
                        },
                        (error) => {
                            console.log(error);
                        }
                    );
            });
        },
        // validEmail: function (email) {
        //     var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        //     return re.test(email);
        // },
        typeChange(typeId) {
            this.getNextCode();
        },
        getNextCode: function () {
            let typeCode = "";
            for(let i=0; i < this.types.length; i++){
                if(this.types[i].categoryId == this.item.typeId){
                    let categoryName = this.types[i].categoryName;
                    typeCode = categoryName.split(/\s/).reduce((response,word)=> response+=word.slice(0,1),'');
                    typeCode = typeCode.toUpperCase();
                    break;
                }
            }

            if(typeCode != ""){
                axios.get(
                    process.env.VUE_APP_API_URL +
                    "/autoIncrease/getNextCode?type=PARTNER_" + typeCode + "&prefix="+typeCode+"&numberZeroBeforeCodeNumberCode=2&suffix="
                ).then((data) => {
                        this.item = Object.assign({}, this.item, {"partnerCode": data})
                    });
            }
        },
    },
    created() {},
};
</script>
